import { isCommentAutopilotSwitchedOn } from '@brand-lolly/app/social-media-influencer/modules/comment-autopilot/services/comment-autopilot-access-state.service';
import { isCommentAutopilotEnabled } from '@brand-lolly/app/social-media-influencer/modules/comment-autopilot/guards/comment-autopilot-enabled.guard';
import { environment } from 'src/environments/environment';

import { NavigationEntryName } from './navigation-product-access';

/**
 * Whether this BUILD shows a rail entry at all — not whether the brand holds its
 * product; that is the route's own treatment.
 *
 * One predicate for the rail and the universal search, so a department this
 * build leaves out of the rail is never offered as a search result either.
 */
export function isNavigationEntryShown(entry: NavigationEntryName): boolean {
	switch (entry) {
		case 'social-listening':
			return (
				environment.Flags.socialListeningEnabled ??
				!environment.Flags.production
			);
		// Visible everywhere but production, the same policy as Social Listening.
		case 'affiliates':
			return !environment.Flags.production;
		// The build flag, then the per-brand switch a platform admin turns on.
		// The switch reads false until the shell has asked the backend, so the
		// entry is absent first and appears when the answer lands.
		case 'comment-autopilot':
			return (
				isCommentAutopilotEnabled() && isCommentAutopilotSwitchedOn()
			);
		default:
			return true;
	}
}
